import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import './App.css';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import ContactUs from './components/Contact/ContactUs';
import Login from './components/Entry/Login';
import SignUp from './components/Entry/SignUp';
import MainDashBoard from './components/Dashboard/MainDashBoard';
import Header from './components/Header/Header';
import Services from './components/Service/Services';
import DashBoardHeader from './components/Dashboard/DashBoardHeader';
import ProfileDetails from './components/Dashboard/ProfileDetails';
import OTP from './components/Entry/OTP';

import WelcomeMessage from './components/Dashboard/WelcomeMassage';
import StepOne from './components/Dashboard/StepOne';
import ForgotPassword from './components/Entry/ForgotPassWord';
import ForgotPassOtp from './components/Entry/ForgotPassOtp';
import NewPassword from './components/Entry/NewPassword';
import EditLoanPage from './components/Dashboard/GridMLR/EditLoanPage';
import UPAS from './components/Dashboard/NewLoanApplication/ApplyType/Upas/UPAS';
import NewLoanApplication from './components/Dashboard/NewLoanApplication/NewLoaApplication';
import Refinance from './components/Dashboard/NewLoanApplication/ApplyType/Refinance/Refinance';
import FirstRefinance from './components/Dashboard/NewLoanApplication/ApplyType/Refinance/FirstRefinance';
import SecondRefinance from './components/Dashboard/NewLoanApplication/ApplyType/Refinance/SecondRefinance';
import EditFirstRefinancePage from './components/Dashboard/NewLoanApplication/ApplyType/Refinance/EditFirstRefinancePage';
import EditSecondRefinancePage from './components/Dashboard/NewLoanApplication/ApplyType/Refinance/EditSecondRefinancePage';


function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(
      () => localStorage.getItem('isLoggedIn') === 'true'
    );
    const [isSignUp, setIsSignUp] = useState(
      () => localStorage.getItem('isSignUp') === 'true'
    );

    useEffect(() => {
      localStorage.setItem('isLoggedIn', isLoggedIn);
    }, [isLoggedIn]);

    useEffect(() => {
      localStorage.setItem('isSignUp', isSignUp);
    }, [isSignUp]);
  
  // const [isLoggedIn, setIsLoggedIn] = useState(() => {
  //   return localStorage.getItem('isLoggedIn') === 'true';
  // });
  // const [isSignUp, setIsSignUp] = useState(() => {
  //   return localStorage.getItem('isSignUp') === 'true';
  // });

  // useEffect(() => {
  //   localStorage.setItem('isLoggedIn', isLoggedIn);
  // }, [isLoggedIn]);

  // useEffect(() => {
  //   localStorage.setItem('isSignUp', isSignUp);
  // }, [isSignUp]);


  const handleLogin = () => {
    setIsLoggedIn(true);
    setIsSignUp(false);
  };

  const handleSignUp = () => {
    setIsLoggedIn(false);
    setIsSignUp(true);
  };
 

  const handleLogout = () => {
    setIsLoggedIn(false);
    setIsSignUp(false);
  };

  return (
    <div className="App">
      <Router>
        {isLoggedIn || isSignUp ? (
          <>
            <DashBoardHeader onLogout={handleLogout} />
            <Routes>
              <Route path="/dashboard" element={<MainDashBoard />} />
              {/* <Route
                path="/signup"
                element={<SignUp onSignUp={handleSignUp} />}
              /> */}
              <Route
                path="/NewLoanApplication"
                element={<NewLoanApplication />}
              />
              <Route path="/upas" element={<UPAS />} />
              <Route path="/refinance" element={<Refinance />} />
              <Route path="/firstRefinance" element={<FirstRefinance />} />
              <Route path="/secondRefinance" element={<SecondRefinance />} />
              <Route path="/profileDetails" element={<ProfileDetails />} />
              <Route path="/edit-loan/:id" element={<EditLoanPage />} />
              <Route
                path="/edit-firstRefinane/:id"
                element={<EditFirstRefinancePage />}
              />
              <Route
                path="/edit-secondRefinane/:id"
                element={<EditSecondRefinancePage />}
              />

              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </>
        ) : (
          <>
            <Header />
            <Routes>
              <Route path="/" element={<Hero />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/newPassword" element={<NewPassword />} />
              <Route path="/forgotPassOtp" element={<ForgotPassOtp />} />
              <Route path="/otp" element={<OTP onSignUp={handleSignUp} />} />

              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contactUs" element={<ContactUs />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </>
        )}
      </Router>
    </div>
  );
}


export default App;
